import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { useQueryMedia } from "../../../../hooks/useQueryMedia";
import AnswerType from "../../../../interfaces/answer/AnswerType";
import AnswerCard from "../../../shared/answer-card/AnswerCard";
import QuestionOrderDown from "../../../shared/icons/QuestionOrderDown";
import QuestionOrderUp from "../../../shared/icons/QuestionOrderUp";
import QuestionCard from "../../../shared/question-card/QuestionCard";
import MyAnswerTabService from "./MyAnswerTabService";

interface MyAnswerTabType {
  answers: AnswerType[];
  callbackRefresh: any;
  callbackQuestionRefresh: any;
  selectedLectures: any;
  selectedCourses: any;
  tabValue: any;
  showAllAnswers: any;
}

const MyAnswerTab = ({ answers, callbackRefresh, callbackQuestionRefresh, selectedCourses, selectedLectures, tabValue, showAllAnswers }: MyAnswerTabType) => {
  const { isMobile } = useQueryMedia();

  const answersIds = answers.map((answer: any) => answer.id);
  const { showQuestions, showQuestionAction } = MyAnswerTabService({ answersIds, showAllAnswers });

  return (
    <Grid container justifyContent="flex-start" alignItems="flex-start" rowSpacing={1} columnSpacing={1}>
      {answers.map((answer: AnswerType) => {
        const showQuestion = showQuestions.includes(answer.id);
        return (
          <Grid key={answer.id} item xs={12} sx={{ paddingLeft: "0px !important", mt: isMobile ? 0 : 2 }} pr={1}>
            <>
              {showQuestions.includes(answer.id) && (
                <Grid sx={{ mb: isMobile ? 0.25 : 0.5 }}>
                  <QuestionCard question={answer.question} callbackRefresh={callbackQuestionRefresh} selectedLectures={selectedLectures} selectedCourses={selectedCourses} tabValue={tabValue} />
                </Grid>
              )}
              <Grid position="relative" display="flex" flexDirection="column">
                {!isMobile ? (
                  <Button endIcon={showQuestion ? <KeyboardArrowDown /> : <KeyboardArrowUp />} className="answer-card-btn-show-answers" onClick={() => showQuestionAction(answer.id)}>
                    {showQuestion ? "hide question" : "show question"}
                  </Button>
                ) : (
                  <>
                    {!showQuestion ? (
                      <div onClick={() => showQuestionAction(answer.id)}>
                        <QuestionOrderDown className={`answer-card-question-order ${showQuestion && "answer-card-question-order-active"}`} />
                      </div>
                    ) : (
                      <div onClick={() => showQuestionAction(answer.id)}>
                        <QuestionOrderUp className={`answer-card-question-order ${showQuestion && "answer-card-question-order-active"}`} />
                      </div>
                    )}
                  </>
                )}
                <AnswerCard answer={answer} questionId={answer.question.id} callbackRefresh={callbackRefresh} />
              </Grid>
            </>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default MyAnswerTab;
